module.exports = __webpack_public_path__ + "img/image-map-2-3560af4b.png";